<template>
  <div class="flex flex-col justify-between flex-grow h-full gap-2">
    <div
      class="flex flex-wrap items-center content-center justify-center h-full gap-x-2 gap-y-3"
      :class="{ 'scale-90': isCollapsed }"
    >
      <div class="space-y-1">
        <div
          class="relative flex items-center justify-center flex-shrink-0 font-bold text-white transition-all duration-300 cursor-pointer h-18 w-18 rounded-3xl bg-light-purple hover:bg-dark-purple-200"
          :class="{
            'cursor-wait': scoreLoading,
            'pointer-events-none': sessionStatus !== 'ongoing'
          }"
          @click="onChangeScore(1)"
        >
          <div v-if="score" class="text-4xl">
            {{ score }}
          </div>
          <div v-else class="text-5xl">+</div>
        </div>
        <div
          class="flex items-center justify-center h-5 transition-all duration-300 border rounded cursor-pointer border-slate-500 bg-pure-white hover:bg-hover-state"
          :class="{
            'cursor-wait': scoreLoading,
            'pointer-events-none': !score || sessionStatus !== 'ongoing'
          }"
          @click="onChangeScore(-1)"
        >
          <div
            class="flex-shrink-0 w-6 h-1 transition-all duration-300 rounded"
            :class="{
              'bg-slate-500': !score,
              'bg-slate-600': score
            }"
          ></div>
        </div>
      </div>
    </div>

    <div v-if="!isCollapsed" class="flex-shrink-0 pb-3 text-center">
      <BlTextBody2 text="Goal:" />
      <BlTextBody2 :text="measurement.target.goal" />
      <BlTextBody2 text="attempt(s) per session" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash/debounce";

import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "MeasurementCardFrequency",
  components: {
    BlTextBody2,
    BlInputButton
  },
  props: {
    measurement: { type: Object, required: true },
    sessionStatus: { type: String, required: true },
    isCollapsed: { type: Boolean, default: false }
    // @toggle-updated
  },
  data() {
    return {
      score: 0,
      scoreLoading: false
    };
  },
  computed: {
    ...mapGetters(["viewMode"]),
    resultScore() {
      return this.measurement.results && this.measurement.results.score;
    }
  },
  watch: {
    scoreLoading(val) {
      if (val === false) {
        this.$emit("toggle-updated", true);
      } else {
        this.$emit("toggle-updated", false);
      }
    }
  },
  mounted() {
    this.score = this.measurement.results && this.measurement.results.score;
  },
  methods: {
    ...mapActions(["updateMeasurementResults"]),
    // ongoing
    onSaveScore: debounce(async function(score) {
      const params = {
        id: this.measurement.id,
        results: score
      };

      this.scoreLoading = true;
      const { success, data } = await this.updateMeasurementResults(params);
      this.scoreLoading = false;
      if (!success) {
        this.score = this.measurement.results && this.measurement.results.score;
        return;
      }

      this.score = data.results && data.results.score;
    }, 1000),
    async onChangeScore(score) {
      if (this.sessionStatus !== "ongoing") return;

      // change state
      this.score += score;

      // save state
      const gapScore = this.score - this.measurement.results.score;
      this.onSaveScore(gapScore);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sessions/card/Frequency.vue